import { usePage } from "@inertiajs/react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { FormError } from "@/components/FormError"

interface PageProps {
  fieldErrors?: Record<string, string>
  [key: string]: unknown
}

export default function ForgotPassword() {
  const { t } = useTranslation()
  const { fieldErrors } = usePage<PageProps>().props
  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">{t("forgotPassword.title")}</CardTitle>
          <CardDescription>{t("forgotPassword.subtitle")}</CardDescription>
        </CardHeader>
        <CardContent>
          <form method="post" action="/reset-password-request" className="space-y-4">
            <input type="hidden" name="authenticity_token" value={csrfToken} />
            <div className="space-y-2">
              <Label htmlFor="email">{t("forgotPassword.emailLabel")}</Label>
              <Input
                id="email"
                name="email"
                type="email"
                placeholder={t("forgotPassword.emailPlaceholder")}
                required
              />
              <FormError error={fieldErrors?.email} />
            </div>

            <Button type="submit" className="w-full">
              {t("forgotPassword.submit")}
            </Button>

            <p className="text-center text-sm text-muted-foreground">
              {t("forgotPassword.rememberPassword")}{" "}
              <a href="/login" className="text-foreground hover:underline">
                {t("forgotPassword.signIn")}
              </a>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
